/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * All possible Unauthorized problems.
 */
export type UnauthorizedProblems = Truvity.UnauthorizedProblems.Unauthorized;

export namespace UnauthorizedProblems {
    export interface Unauthorized extends Truvity.ProblemUnauthorized {
        type: '/unauthorized';
    }
}
